import { useSelector } from 'react-redux'
import { RootState } from 'redux/reducers'

export default function useProductTour() {
  return useSelector((state: RootState) => state.common.isTourOpen)
}
